  (function (){
    const footer_accordion_buttons= document.querySelectorAll('.mfooter-block-menu-header');
    footer_accordion_buttons.forEach(btn=>{
      btn.addEventListener('click',e=>{
        btn.classList.toggle("active");
        var panel = btn.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      })
    })
  })()